import { type AppNode, type VideoNodeData } from '../types';

/**
 * Extracts video node data for sync. Backend uses media.original for video URLs.
 */
export const getVideoNodeData = (node: AppNode): VideoNodeData | undefined => {
  if (node.type !== 'video') {
    return undefined;
  }

  const { data } = node;

  if (!data.media?.original || !data.source) {
    return undefined;
  }

  return {
    assetId: data.assetId,
    fileName: data.fileName ?? '',
    media: { original: data.media.original },
    prompt: data.prompt,
    // Without this the node loses its format on reload and the platform preview
    // button disappears, since preview eligibility is keyed on the format id.
    smartResizeFormatId: data.smartResizeFormatId,
    source: data.source,
    type: 'video',
    versionId: data.versionId,
  };
};
